import { render, staticRenderFns } from "./ScatterChart.vue?vue&type=template&id=227bf42e&scoped=true&"
import script from "./ScatterChart.vue?vue&type=script&lang=js&"
export * from "./ScatterChart.vue?vue&type=script&lang=js&"
import style0 from "./ScatterChart.vue?vue&type=style&index=0&id=227bf42e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227bf42e",
  null
  
)

export default component.exports